import type Path from "src/constants/path";

export default function createPath(str: string): Path {
  return str as unknown as Path;
}
